import React, { FC } from 'react';
import { InfoCircleOutlined, StopOutlined, WarningOutlined } from '@ant-design/icons';
import {
  Col,
  Row,
  Skeleton,
  Statistic,
  Tooltip,
} from 'antd';

interface Props {
  errorCount: number,
  warningCount: number,
  infoCount: number,
  isLoading?: boolean,
}

const UpdateToolLogStats: FC<Props> = ({
  errorCount,
  warningCount,
  infoCount,
  isLoading,
}) => (
  <Row gutter={16} style={{ marginTop: 32, marginBottom: 64, textAlign: 'center' }}>
    <Col span={8}>
      {
        isLoading ? <Skeleton.Input active /> : (
          <Tooltip
            title="These are critical/blockers and must be resolved before you can apply"
          >
            <Statistic
              prefix={<StopOutlined style={{ color: 'red' }} />}
              value={errorCount}
              suffix="errors"
            />
          </Tooltip>
        )
      }
    </Col>
    <Col span={8}>
      {
        isLoading ? <Skeleton.Input active /> : (
          <Tooltip title="These are not necessarily critical/blockers, but involve changes.">
            <Statistic
              prefix={<WarningOutlined style={{ color: 'orange' }} />}
              value={warningCount}
              suffix="warnings"
            />
          </Tooltip>
        )
      }
    </Col>
    <Col span={8}>
      {
        isLoading ? <Skeleton.Input active /> : (
          <Tooltip title="There are non-critical changes that may affect the output.">
            <Statistic
              prefix={<InfoCircleOutlined style={{ color: '#1b55e3' }} />}
              value={infoCount}
              suffix="info"
            />
          </Tooltip>
        )
      }
    </Col>
  </Row>
);

export default UpdateToolLogStats;
